"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/objectSpread2.js"));
var _slicedToArray2 = _interopRequireDefault(require("/Users/robertvunabandi/Desktop/Projects/aidos-server-python/node_modules/@babel/runtime/helpers/esm/slicedToArray.js"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _ChoicePicker = _interopRequireWildcard(require("web/shared/telemetry/components/ChoicePicker"));
var _Icon = _interopRequireDefault(require("web/shared/icons/Icon"));
var _MeasurementRow = _interopRequireDefault(require("web/shared/telemetry/charts/MeasurementRow"));
var _MeasurementsTableData = require("web/shared/telemetry/charts/MeasurementsTable.data.js");
var _perfTablesStyles = require("web/shared/telemetry/perfTables.styles.js");
var _perfViewsStyles = require("web/shared/telemetry/perfViews.styles.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
* The individual measurements behind every other panel on the page.
*
* It owns its own ordering and paging because both are pure display over
* measurements already fetched: changing either rearranges the table rather
* than blanking it while a request goes out.
*/ // The page sizes this table offers. It pages over what one read already
// brought back, so these are a choice about the screen rather than about the
// request, and nothing in the schema names them.
const PAGE_SIZE_CHOICES = [20, 50, 100];
const PAGE_SIZE_OPTIONS = (0, _ChoicePicker.numberChoices)(PAGE_SIZE_CHOICES, size => "".concat(size, "/page"));
function MeasurementsTable(_ref) {
  let records = _ref.records;
  const _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    slowestFirst = _useState2[0],
    setSlowestFirst = _useState2[1];
  const _useState3 = (0, _react.useState)(PAGE_SIZE_CHOICES[0]),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    pageSize = _useState4[0],
    setPageSize = _useState4[1];
  const _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
    page = _useState6[0],
    setPage = _useState6[1];
  const listed = (0, _MeasurementsTableData.orderRecords)(records, slowestFirst);
  const _pageOf = (0, _MeasurementsTableData.pageOf)(listed, pageSize, page),
    currentPage = _pageOf.currentPage,
    pageCount = _pageOf.pageCount,
    visible = _pageOf.visible;
  const windowHeat = (0, _MeasurementsTableData.heatBounds)(records);
  const pageHeat = (0, _MeasurementsTableData.heatBounds)(visible);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("section", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.wideCard)), {}, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.panelHeader)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("h2", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.subHeading)), {}, {
        children: "Measurements"
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.controls)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
          type: "button",
          onClick: () => setSlowestFirst(!slowestFirst)
        }, stylex.props(_perfViewsStyles.styles.button, slowestFirst && _perfViewsStyles.styles.buttonActive)), {}, {
          children: slowestFirst ? "slowest first" : "newest first"
        })), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChoicePicker.default, {
          options: PAGE_SIZE_OPTIONS,
          selected: pageSize,
          onPick: size => {
            setPageSize(size);
            setPage(0);
          }
        })]
      }))]
    })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.tableWrap)), {}, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("table", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.table)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("thead", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("tr", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.headCell)), {}, {
              children: "started"
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericHeadCell)), {}, {
              children: "duration"
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.headCell)), {}, {
              children: "trace"
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.numericHeadCell)), {}, {
              children: "sampled"
            })), /*#__PURE__*/(0, _jsxRuntime.jsx)("th", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfTablesStyles.styles.headCell)), {}, {
              children: "dimensions"
            }))]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
          children: visible.map(record => /*#__PURE__*/(0, _jsxRuntime.jsx)(_MeasurementRow.default, {
            record: record,
            slowestMs: windowHeat.slowestMs,
            heatFastestMs: pageHeat.fastestMs,
            heatSlowestMs: pageHeat.slowestMs
          }, record.id))
        })]
      }))
    })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.pager)), {}, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
        type: "button",
        onClick: () => setPage(currentPage - 1),
        disabled: currentPage === 0
      }, stylex.props(_perfViewsStyles.styles.button)), {}, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
          name: "arrow-left",
          size: "xs"
        }), " newer"]
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", (0, _objectSpread2.default)((0, _objectSpread2.default)({}, stylex.props(_perfViewsStyles.styles.mono, _perfViewsStyles.styles.muted)), {}, {
        children: "".concat(currentPage * pageSize + 1, "\u2013") + "".concat(currentPage * pageSize + visible.length, " ") + "of ".concat(listed.length)
      })), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", (0, _objectSpread2.default)((0, _objectSpread2.default)({
        type: "button",
        onClick: () => setPage(currentPage + 1),
        disabled: currentPage >= pageCount - 1
      }, stylex.props(_perfViewsStyles.styles.button)), {}, {
        children: ["older ", /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.default, {
          name: "arrow-right",
          size: "xs"
        })]
      }))]
    }))]
  }));
}
var _default = exports.default = MeasurementsTable;